module.exports = __webpack_public_path__ + "img/clock-white.c17149f9.svg";